export const items = [
  { id: 1, name: "Item One", description: "This is the first item." },
  { id: 2, name: "Item Two", description: "This is the second item." },
  { id: 3, name: "Item Three", description: "This is the third item." }
];